<template>
  <div
    class="container"
  >
    <HomeHeader @selectedRegionUpdate="filterCountries" />
    <div v-if="!error">
      <CountriesCardsList
        :countries="countries"
        :loading="loading"
        :error="error"
      />
    </div>
    <div v-else>
      Something went wrong
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import useCountries from '@/composables/useCountries';
import useScroll from '@/composables/useScroll';

import HomeHeader from '@/components/HomeHeader.vue';
import CountriesCardsList from '@/components/CountriesCardsList.vue';

export default {
  name: 'Home',
  components: {
    HomeHeader,
    CountriesCardsList,
  },

  setup() {
    const {
      countriesToDisplay: countries,
      loading,
      error,
      filterByRegion,
      numberOfCountriesToDisplay,
    } = useCountries('https://restcountries.eu/rest/v2/all', { lazy: true });

    console.log(123);
    const filterCountries = (region) => {
      filterByRegion(region.value);
    };

    useScroll(document.body, () => {
      numberOfCountriesToDisplay.value += 20;
    });

    return {
      filterCountries,
      countries,
      loading,
      error,
    };
  },
};
</script>

<style lang="scss" module>

</style>
